import SearchPagePublic from './search-page-container';

export default SearchPagePublic;